<template>
  <div class="form-title">
    <slot />
  </div>
</template>
<script>
export default {
  name: 'FormTitle',
};
</script>
<style lang="scss" scoped>
.form-title {
  color: rgba($--base-color-black, 0.8);
  font-size: 16px;
  padding: 4px 10px;
  position: relative;
  font-weight: 500;
  margin: 20px auto 16px;
  &::after {
    content: '';
    position: absolute;
    width: 2px;
    top: 4px;
    bottom: 4px;
    left: 0;
    background: $--base-color-main;
  }
}
</style>
